/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stretch_ShrinkInputs */

const en_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stretch/Shrink...`)
};

const fr_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étirer/Réduire...`)
};

const de_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dehnen/Schrumpfen...`)
};

const it_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allungare/Restringere...`)
};

const ru_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Растяжение/сжатие...`)
};

const es_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estirar/Encoger...`)
};

const zh_cn2_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拉伸/收缩……`)
};

const ja_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伸縮...`)
};

const hi_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिंचाव/सिकुड़न...`)
};

const pt_pt2_stretch_shrink = /** @type {(inputs: Stretch_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esticar/Encolher...`)
};

/**
* | output |
* | --- |
* | "Stretch/Shrink..." |
*
* @param {Stretch_ShrinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const stretch_shrink = /** @type {((inputs?: Stretch_ShrinkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stretch_ShrinkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_stretch_shrink(inputs)
	if (locale === "de") return de_stretch_shrink(inputs)
	if (locale === "it") return it_stretch_shrink(inputs)
	if (locale === "ru") return ru_stretch_shrink(inputs)
	if (locale === "es") return es_stretch_shrink(inputs)
	if (locale === "zh-CN") return zh_cn2_stretch_shrink(inputs)
	if (locale === "ja") return ja_stretch_shrink(inputs)
	if (locale === "hi") return hi_stretch_shrink(inputs)
	if (locale === "pt-PT") return pt_pt2_stretch_shrink(inputs)
	return en_stretch_shrink(inputs)
});